import { InputProps } from '../types'
import InputGroupWrapper from '../../../components/ui/InputGroupeWrapper'
import { InputGroupAddon } from '@playbooks/ui/components/input-group'
import { useTranslation } from '../../../contexts/localization/Localization'
import { CalcErrorCode } from '@playbooks/action-cards-utils/actionCard'
import { useMemo } from 'react'

/**
 * Formula Component
 *
 * Displays the calculated value of a formula and handles localized error
 * messaging when calculation fails.
 */
export default function Formula({ question }: Omit<InputProps<number>, 'value'>) {
  const { text: t } = useTranslation()

  const errorMessage = useMemo(() => {
    switch (question.error) {
      case CalcErrorCode.INVALID_SYNTAX:
        return t('formula_error_syntax')
      case CalcErrorCode.MISSING_VARIABLE:
        return t('formula_error_missing_var')
      case CalcErrorCode.EMPTY_EXPRESSION:
        return t('formula_error_empty')
      case CalcErrorCode.UNKNOWN:
        return t('formula_error_unknown')
    }
  }, [t, question.error])

  return (
    <>
      <InputGroupWrapper className="flex items-center">
        <InputGroupAddon>
          {question.error == CalcErrorCode.DIVISION_BY_ZERO ? '∞' : question.value?.toString()}
        </InputGroupAddon>

        {errorMessage && (
          <div className="AC_errorMessage text-[red] text-[12px] absolute -bottom-5">{errorMessage}</div>
        )}
      </InputGroupWrapper>
    </>
  )
}
